import { useQueryWithUserId } from '@northladder/services';
import { IApiError } from '@northladder/utilities';

import { B2B_SERVICE_API } from '../b2bApiClient';
import { IEntQuoteDetailsData } from '../types';

/**
 * Query key for enterprise customer quote details caching.
 */
export const FETCH_ENT_CUSTOMER_QUOTE_DETAILS_QUERY_KEY =
  'enterprise-quotes-details-key';

/**
 * It returns the query for the mock enterprise quotes requests data.
 */
export function useEnterpriseQuoteDetailsQuery(
  id: string,
  type: string = 'customer'
) {
  /**
   * Cache stale time for the enterprise quote requests details to 30 seconds.
   */
  const CACHE_STALE_TIME = 30000;

  return useQueryWithUserId<IEntQuoteDetailsData, IApiError>({
    queryKey: [FETCH_ENT_CUSTOMER_QUOTE_DETAILS_QUERY_KEY, id, type],
    queryFn: () => B2B_SERVICE_API.fetchEntQuotesDetails(id, type),
    staleTime: CACHE_STALE_TIME,
  });
}
